import { useStore } from '@/store';
import { selectFormula } from '@/store/selectors';

/** Render the substituted formula breakdown (F-035, P1.6.2). */
export function FormulaBreakdown() {
  const formula = useStore(selectFormula);
  if (!formula) return null;

  return (
    <details className="formula-block" open>
      <summary className="field-label cursor-pointer mt-3">
        Formula breakdown
      </summary>
      <div className="formula-symbolic">{formula.symbolic}</div>
      <div className="formula-substituted">{formula.substituted}</div>
      {formula.steps.length > 0 ? (
        <ol className="formula-steps">
          {formula.steps.map((step, i) => (
            <li key={i}>
              <strong>{step.label}:</strong> {step.expression}
            </li>
          ))}
        </ol>
      ) : null}
    </details>
  );
}
